import React, { useState, useEffect } from "react";
import { FcCheckmark } from "react-icons/fc";
import { TiTimes, TiTick } from "react-icons/ti";
import { MdOutlineContentCopy } from "react-icons/md";
import Tooltip from "../../../../../../Components/Tooltip/Tooltip";
import noImage from "../../../../../../assets/images/noImage.png";
import ImagesModal from "../../../../../Shipper/Customer/MainPages/Orders/Components/OrderHistoryModal/ImagesModal/ImagesModal";
import ShipmentHistoryModal from "../../../../../../Components/ShipmentHistoryModal/ShipmentHistoryModal";
import StatusIcons from "../../../../../../Components/StatusIcons/StatusIcons";
import { MdOutlineHistory } from "react-icons/md";
import { useSelector } from "react-redux";
import HyperLink from "../../../../../../Components/HyperLink/HyperLink";
import { seesOrderPrices } from "../../../../../../helpers/storeAccess";
import { useTranslation } from "react-i18next";

export default function ShipmentSummary({
  data,
  selectedStatus,
  type = "show",
  orderStatus,
}) {
  const { t } = useTranslation(["warehouse", "common"]);
  const user = useSelector((state) => state.user);
  // Amounts and item values need "View price"; a cash order's amount to
  // collect still shows, as the server sends it to every role.
  const showPrices = seesOrderPrices(user);
  const showPending = showPrices || data?.amount_pending != null;
  const [copied, setCopied] = useState(false);
  const [fullview, setfullview] = useState();

  const [ShopifyProducts, setShopifyProducts] = useState([]);
  const [BoltProducts, setBoltProducts] = useState([]);

  useEffect(() => {
    if (data?.order_details?.length) {
      const shopifyItems = [];
      const boltItems = [];

      for (const item of data.order_details) {
        if (item.plugin_item_id) {
          shopifyItems.push(item);
        } else {
          boltItems.push(item);
        }
      }

      setShopifyProducts(shopifyItems);
      setBoltProducts(boltItems);
    }
  }, [data?.order_details]);

  function findOrderById(orderId) {
    const foundOrder = orderStatus.find((order) => order.id === orderId);
    return foundOrder?.name?.toUpperCase() ?? "";
  }

  const [detailHistoryModal, setDetailHistoryModal] = useState(false);

  const handleCopy = () => {
    let shipmentIds = [];
    for (let i = 0; i < data?.c_p_shipment_details.length; i++) {
      let shipmentId = data?.c_p_shipment_details[i]?.shipment_tracking_id;
      shipmentIds.push(shipmentId);
    }
    let shipmentIdsString = shipmentIds.join(",\n");
    navigator.clipboard
      .writeText(shipmentIdsString)
      .then(() => {
        setCopied("sid");
      })
      .catch((error) => {
        console.error(
          "Failed to copy shipment tracking IDs to clipboard: " + error,
        );
      });

    setTimeout(() => setCopied(false), 2000);
  };

  const handleCopyParcelId = () => {
    let parcelIds = [];
    data?.shipment?.shipment_details.map((item) => {
      parcelIds.push(item?.parcel_id);
    });
    // for (let i = 0; i < data?.shipment?.parcel_id?.length; i++) {
    //   let parcelId = data?.shipment?.parcel_id[i] ?? "";
    //   parcelIds.push(parcelId);
    // }
    let parcelIdsString = parcelIds.join(",\n");
    navigator.clipboard
      .writeText(parcelIdsString)
      .then(() => {
        setCopied("pid");
      })
      .catch((error) => {
        console.error("Failed to copy parcel IDs to clipboard: " + error);
      });

    setTimeout(() => setCopied(false), 2000);
  };

  function getMediaSrc(singlelist) {
    const primaryMedia = singlelist?.media?.find(
      (media) => media.is_primary === "true",
    );
    const file = primaryMedia?.file || singlelist?.media?.[0]?.file;

    return file ?? noImage;
  }

  function getFulfilledQty(pallet, index) {
    const order_id = data?.id;

    const matchingHistory = pallet?.pallet_history
      ?.sort((a, b) => b.id - a.id) // Sorting in descending order by id
      ?.find((history) => history?.properties?.order_id === order_id);

    if (matchingHistory) {
      const total =
        (matchingHistory?.properties?.previous_quantity || 0) -
        (matchingHistory?.properties?.updated_quantity || 0);

      return total > 0 ? (
        <>
          <tr
            style={{
              borderTop: "0.5px solid grey",
            }}
            key={index}
          >
            <td style={{ borderRight: "0.5px solid grey" }}>
              {pallet?.pallet?.name ?? "N/A"}
            </td>
            <td style={{ borderRight: "0.5px solid grey" }}>
              {pallet?.product_lot?.name ?? "N/A"}
            </td>
            <td style={{ borderRight: "0.5px solid grey" }}>
              {pallet?.pallet?.location?.name ?? "N/A"}
            </td>
            <td>{total ?? "N/A"}</td>
          </tr>
        </>
      ) : null;
    }

    return null;
  }

  return (
    <>
      <ShipmentHistoryModal
        open={detailHistoryModal}
        setOpen={setDetailHistoryModal}
      />
      <ImagesModal setOpen={setfullview} open={fullview} />
      <div className="invmodal__shipment_details invmodal__ship_details_wrap">
        <div className="invmodal__shipment_detailshding order_detail_heading">
          {t("orderDetails.orderDetails")}
        </div>
        <div className="invmodal__shdetails_content">
          <div className="invmodal__shdetails_cntleft">
            <table className="invmodal__shdetails_table order__detail_table_wrap">
              <thead>
                <th className="invmodal__shdetails_tablehd">{t("orderDetails.orderType")}</th>
                {/* <th className="invmodal__shdetails_tablehd">Order Id</th> */}
                <th className="invmodal__shdetails_tablehd">{t("orderDetails.orderStatus")}</th>
                <th className="invmodal__shdetails_tablehd">{t("orderDetails.paymentMethod")}</th>
                {showPending && (
                  <th className="invmodal__shdetails_tablehd">
                    {t("orderDetails.amountPending")}
                  </th>
                )}
                {data?.typeamount_received_by_warehouse && (
                  <th className="invmodal__shdetails_tablehd">
                    {t("orderDetails.amountReceived")}
                  </th>
                )}
                <th className="invmodal__shdetails_tablehd">
                  {t("orderDetails.fulfilmentStatus")}
                </th>
                {/* <th className="invmodal__shdetails_tablehd">Fulfilment Cost</th> */}
              </thead>
              {/* data-label / data-card: how a cell reads as a card on phones
                  and tablets (OrderDetails.css); tables stay as they are on
                  desktop and in the PDF. */}
              <tbody>
                <tr>
                  <td
                    className="invmodal__shdetails_tableitem"
                    data-label={t("orderDetails.orderType")}
                  >
                    {data?.type ?? "-"}
                  </td>
                  {/* <td className="invmodal__shdetails_tableitem">
                    {data?.order_id ?? "-"}
                  </td> */}
                  <td
                    className="invmodal__shdetails_tableitem"
                    data-label={t("orderDetails.orderStatus")}
                  >
                    {data?.status ?? "-"}
                  </td>
                  <td
                    className="invmodal__shdetails_tableitem"
                    data-label={t("orderDetails.paymentMethod")}
                  >
                    {data?.payment_method_title ?? "-"}
                  </td>
                  {showPending && (
                    <td
                      className="invmodal__shdetails_tableitem"
                      data-label={t("orderDetails.amountPending")}
                    >
                      {data?.amount_pending ?? "0"} $
                    </td>
                  )}
                  {data?.typeamount_received_by_warehouse && (
                    <td
                      className="invmodal__shdetails_tableitem"
                      data-label={t("orderDetails.amountReceived")}
                    >
                      {data?.amount_received_by_warehouse ?? "0"} $
                    </td>
                  )}
                  <td
                    className="invmodal__shdetails_tableitem"
                    data-label={t("orderDetails.fulfilmentStatus")}
                  >
                    {findOrderById(selectedStatus) ?? "-"}
                  </td>
                  {/* <td className="invmodal__shdetails_tableitem">
                    {data?.fulfillment_cost ?? "0"} $
                  </td> */}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="invmodal__shipment_summaryhding order_detail_heading">
          {t("orderDetails.shipmentDetails")}
        </div>
        {data?.shipment && (
          <div className="invmodal__shdetails_content">
            <div className="invmodal__shdetails_cntleft">
              <table className="invmodal__shdetails_table order__detail_table_wrap">
                <thead>
                  <th className="invmodal__shdetails_tablehd">{t("orderDetails.carrier")}</th>
                  <th className="invmodal__shdetails_tablehd">{t("orderDetails.serviceType")}</th>
                  <th className="invmodal__shdetails_tablehd">
                    {t("orderDetails.shipmentStatus")}
                  </th>
                  <th className="invmodal__shdetails_tablehd">{t("orderDetails.pickupId")}</th>
                  <th className="invmodal__shdetails_tablehd">{t("orderDetails.pickupDate")}</th>
                  <th className="invmodal__shdetails_tablehd">{t("orderDetails.boltTracking")}</th>
                  <th className="invmodal__shdetails_tablehd">
                    {t("orderDetails.carrierTracking")}
                  </th>
                  <th className="invmodal__shdetails_tablehd">{t("orderDetails.time")}</th>
                </thead>
                <tbody>
                  {" "}
                  <tr>
                    {" "}
                    <td
                      className="invmodal__shdetails_tableitem"
                      data-label={t("orderDetails.carrier")}
                    >
                      <img
                        src={
                          `${data?.shipment?.shipping_company?.shipping_company?.logo_url}` ||
                          noImage
                        }
                        alt=""
                        loading="lazy"
                        onError={(e) => {
                          e.target.src = noImage;
                        }}
                        className="invmodal__shdetailgi_carrlogo"
                      />
                    </td>
                    <td
                      className="invmodal__shdetails_tableitem"
                      data-label={t("orderDetails.serviceType")}
                    >
                      {data?.shipment?.service_type ?? "-"}
                    </td>
                    <td
                      className="invmodal__shdetails_tableitem"
                      data-label={t("orderDetails.shipmentStatus")}
                    >
                      {data?.shipment?.shipment_status ?? "-"}
                    </td>
                    <td
                      className="invmodal__shdetails_tableitem"
                      data-label={t("orderDetails.pickupId")}
                    >
                      {data?.shipment?.PickupID ?? "-"}
                    </td>
                    <td
                      className="invmodal__shdetails_tableitem"
                      data-label={t("orderDetails.pickupDate")}
                    >
                      {data?.shipment?.PickupDate?.slice(0, 10) ?? "-"}
                    </td>
                    <td
                      className="invmodal__shdetails_tableitem"
                      data-label={t("orderDetails.boltTracking")}
                    >
                      <HyperLink code={data?.shipment?.tracking_id} />
                    </td>
                    <td
                      className="invmodal__shdetails_tableitem"
                      data-label={t("orderDetails.carrierTracking")}
                    >
                      <HyperLink code={data?.shipment?.shipment_tracking_id} />
                    </td>
                    <td
                      className="invmodal__shdetails_tableitem"
                      data-label={t("orderDetails.time")}
                    >
                      {t("orderDetails.timeRange", {
                        from: data?.shipment?.readyopentime ?? "-",
                        to: data?.shipment?.readyclosetime ?? "-",
                      })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
        {data?.manual_shipment && (
          <div className="invmodal__shdetails_content">
            <div className="invmodal__shdetails_cntleft">
              <table className="invmodal__shdetails_table order__detail_table_wrap">
                <thead>
                  <th className="invmodal__shdetails_tablehd">{t("orderDetails.carrier")}</th>
                  <th className="invmodal__shdetails_tablehd">{t("orderDetails.type")}</th>
                  <th className="invmodal__shdetails_tablehd">
                    {t("orderDetails.shipmentStatus")}
                  </th>
                  <th className="invmodal__shdetails_tablehd">{t("orderDetails.pickupId")}</th>
                  <th className="invmodal__shdetails_tablehd">{t("orderDetails.pickupDate")}</th>
                  <th className="invmodal__shdetails_tablehd">
                    {t("orderDetails.carrierTracking")}
                  </th>
                </thead>
                <tbody>
                  {" "}
                  <tr>
                    {" "}
                    <td
                      className="invmodal__shdetails_tableitem"
                      data-label={t("orderDetails.carrier")}
                    >
                      {data?.manual_shipment?.shipping_company
                        ?.shipping_company && (
                        <img
                          src={
                            `${data?.manual_shipment?.shipping_company?.shipping_company?.logo_url}` ||
                            noImage
                          }
                          alt=""
                          loading="lazy"
                          onError={(e) => {
                            e.target.src = noImage;
                          }}
                          className="invmodal__shdetailgi_carrlogo"
                        />
                      )}
                      {data?.manual_shipment?.manual_shipping_company &&
                        (data?.manual_shipment?.manual_shipping_company
                          ?.shipping_company_name ??
                          "-")}
                      {!data?.manual_shipment?.shipping_company &&
                        !data?.manual_shipment?.manual_shipping_company &&
                        "-"}
                    </td>
                    <td
                      className="invmodal__shdetails_tableitem"
                      data-label={t("orderDetails.type")}
                    >
                      {data?.manual_shipment ? t("orderDetails.manualShipment") : "-"}
                    </td>
                    <td
                      className="invmodal__shdetails_tableitem"
                      data-label={t("orderDetails.shipmentStatus")}
                    >
                      {data?.manual_shipment?.shipment_status ?? "-"}
                    </td>
                    <td
                      className="invmodal__shdetails_tableitem"
                      data-label={t("orderDetails.pickupId")}
                    >
                      {data?.manual_shipment?.pickup_id ?? "-"}
                    </td>
                    <td
                      className="invmodal__shdetails_tableitem"
                      data-label={t("orderDetails.pickupDate")}
                    >
                      {data?.manual_shipment?.pickup_date ?? "-"}
                    </td>
                    <td
                      className="invmodal__shdetails_tableitem"
                      data-label={t("orderDetails.carrierTracking")}
                    >
                      {data?.manual_shipment?.shipment_tracking_id ?? "-"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
        {!data?.shipment && !data?.manual_shipment && (
          <div className="shipment_order_not_available">
            <p>{t("orderDetails.shipmentNotAvailable")} </p>
          </div>
        )}
        {user?.role != "warehouseUser" && ShopifyProducts?.length > 0 ? (
          <>
            <div
              className="invmodal__shipment_summaryhding product_detail_heading"
              style={{ marginTop: "5px" }}
            >
              {t("orderDetails.syncedProductDetails")}
            </div>

            <div className="invmodal__shdetails_content product_detail_table_box">
              <div className="invmodal__shdetails_cntleft">
                <table className="invmshdetails_cnleft_table order__detail_product_detail_table">
                  <thead>
                    <th className="ordedetail__shdetails_tablehd">#</th>
                    <th className="ordedetail__shdetails_tablehd">{t("orderDetails.name")}</th>
                    <th className="ordedetail__shdetails_tablehd">{t("orderDetails.sku")}</th>
                    <th className="ordedetail__shdetails_tablehd">{t("orderDetails.qty")}</th>
                    <th className="ordedetail__shdetails_tablehd">
                      {t("orderDetails.dimLxwxh")}
                    </th>
                    <th className="ordedetail__shdetails_tablehd">{t("orderDetails.weight")}</th>
                    {showPrices && (
                      <th className="ordedetail__shdetails_tablehd">
                        {t("orderDetails.itemValue")}
                      </th>
                    )}
                  </thead>

                  <tbody>
                    {ShopifyProducts?.map((item, index) => {
                      return (
                        <tr key={index}>
                          {" "}
                          <td
                            className="ordedetail__shdetails_tableitem"
                            data-card="media"
                          >
                            <img
                              src={item?.shopify_image ?? noImage}
                              loading="lazy"
                              onError={(e) => {
                                e.target.src = noImage;
                              }}
                              style={{ cursor: "pointer" }}
                              alt=""
                              className="product__table_mainimg"
                              onClick={() => {
                                setfullview(item?.shopify_image ?? noImage);
                              }}
                            />
                          </td>
                          <td
                            className="ordedetail__shdetails_tableitem"
                            data-card="title"
                          >
                            {item?.product_name ?? "-"}
                          </td>
                          <td
                            className="ordedetail__shdetails_tableitem"
                            data-label={t("orderDetails.sku")}
                          >
                            {item?.sku ?? "-"}
                          </td>
                          <td
                            className="ordedetail__shdetails_tableitem"
                            data-label={t("orderDetails.qty")}
                          >
                            {item?.item_quantity ?? "-"}
                          </td>
                          <td
                            className="ordedetail__shdetails_tableitem"
                            data-label={t("orderDetails.dimLxwxh")}
                          >
                            {item?.length ?? "0"} x{item?.width ?? "0"} x
                            {item?.height ?? "0"}
                            {item?.product_length_type === "Imperial"
                              ? ` ${t("units.in")}`
                              : ` ${t("units.cm")}`}
                          </td>
                          <td
                            className="ordedetail__shdetails_tableitem"
                            data-label={t("orderDetails.weight")}
                          >
                            {item?.weight ?? "0"}
                            {item?.product_length_type === "Imperial"
                              ? ` ${t("units.lb")}`
                              : ` ${t("units.kg")}`}
                          </td>
                          {showPrices && (
                            <td
                              className="ordedetail__shdetails_tableitem"
                              data-label={t("orderDetails.itemValue")}
                            >
                              {item?.item_total ?? "0"}
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="invmodal__shdetails_cntright">
                {/* <div className="add__dimension_button">
                <div className="add__dimension_buttonicon">
                  <AddIcon />{" "}
                </div>
                <div className="add__dimension_buttontext">
                  Billed Dimension, Weight and Volume
                </div>
              </div> */}
              </div>
            </div>
          </>
        ) : null}

        <div
          className="invmodal__shipment_summaryhding product_detail_heading"
          style={{ marginTop: "5px" }}
        >
          {t("orderDetails.boltProductDetails")}
        </div>
        {BoltProducts?.length > 0 ? (
          <div className="invmodal__shdetails_content product_detail_table_box">
            <div className="invmodal__shdetails_cntleft">
              <table className="invmshdetails_cnleft_table order__detail_product_detail_table">
                <thead>
                  <th className="ordedetail__shdetails_tablehd">#</th>
                  <th className="ordedetail__shdetails_tablehd">{t("orderDetails.name")}</th>
                  <th className="ordedetail__shdetails_tablehd">{t("orderDetails.sku")}</th>
                  <th className="ordedetail__shdetails_tablehd">{t("orderDetails.qty")}</th>
                  <th className="ordedetail__shdetails_tablehd">{t("orderDetails.lotBatch")}</th>
                  <th className="ordedetail__shdetails_tablehd">{t("orderDetails.desc")}</th>
                  <th className="ordedetail__shdetails_tablehd">{t("orderDetails.dimLxwxh")}</th>
                  <th className="ordedetail__shdetails_tablehd">{t("orderDetails.weight")}</th>
                  {showPrices && (
                    <th className="ordedetail__shdetails_tablehd">{t("orderDetails.preCost")}</th>
                  )}
                  <th className="ordedetail__shdetails_tablehd">
                    {t("orderDetails.productNotes")}
                  </th>
                  {selectedStatus == "5" && (
                    <>
                      <th
                        className="ordedetail__shdetails_tablehd"
                        // style={{ maxWidth: "150px" }}
                      >
                        {t("orderDetails.fulfilled")}
                      </th>
                      <th
                        className="ordedetail__shdetails_tablehd"
                        // style={{ color: "red" }}
                      >
                        {t("orderDetails.fulfilledQty")}
                      </th>
                      <th
                        className="ordedetail__shdetails_tablehd"
                        // style={{ color: "red" }}
                      >
                        {t("orderDetails.fulfilmentNotes")}
                      </th>
                    </>
                  )}
                  <th className="ordedetail__shdetails_tablehd">
                    {t("orderDetails.locationHistory")}
                  </th>
                </thead>

                <tbody>
                  {BoltProducts?.map((item, index) => {
                    return (
                      <tr key={index}>
                        {" "}
                        <td
                          className="ordedetail__shdetails_tableitem"
                          data-card="media"
                        >
                          <img
                            src={getMediaSrc(item?.products)}
                            loading="lazy"
                            onError={(e) => {
                              e.target.src = noImage;
                            }}
                            style={{ cursor: "pointer" }}
                            alt=""
                            className="product__table_mainimg"
                            onClick={() => {
                              setfullview(getMediaSrc(item?.products));
                            }}
                          />
                        </td>
                        <td
                          className="ordedetail__shdetails_tableitem"
                          data-card="title"
                          // style={{ maxWidth: "150px" }}
                        >
                          {item?.products?.name ?? "-"}
                        </td>
                        <td
                          className="ordedetail__shdetails_tableitem"
                          data-label={t("orderDetails.sku")}
                          // style={{ maxWidth: "150px" }}
                        >
                          {item?.products?.code ?? "-"}
                        </td>
                        <td
                          className="ordedetail__shdetails_tableitem"
                          data-label={t("orderDetails.qty")}
                        >
                          {item?.item_quantity ?? "-"}
                        </td>
                        <td
                          className="ordedetail__shdetails_tableitem"
                          data-label={t("orderDetails.lotBatch")}
                          // style={{ maxWidth: "150px" }}
                        >
                          {item?.order_item_product_lot_quantities?.map(
                            (product_lot, index) => (
                              <React.Fragment key={index}>
                                {product_lot?.product_lot?.name} (
                                {product_lot?.quantity})
                                <br />
                              </React.Fragment>
                            ),
                          )}
                        </td>
                        <td
                          className="ordedetail__shdetails_tableitem"
                          data-label={t("orderDetails.desc")}
                          data-card="wide"
                          // style={{ maxWidth: "150px" }}
                        >
                          {item?.products?.description ?? "-"}
                        </td>
                        <td
                          className="ordedetail__shdetails_tableitem"
                          data-label={t("orderDetails.dimLxwxh")}
                        >
                          {item?.products?.length ?? "0"} x
                          {item?.products?.width ?? "0"} x
                          {item?.products?.height ?? "0"}
                        </td>
                        <td
                          className="ordedetail__shdetails_tableitem"
                          data-label={t("orderDetails.weight")}
                        >
                          {item?.products?.weight ?? "0"}
                          {item?.products?.weight_unit ?? ""}
                        </td>
                        {showPrices && (
                          <td
                            className="ordedetail__shdetails_tableitem"
                            data-label={t("orderDetails.preCost")}
                          >
                            {item?.products?.fulfillment_cost ?? "-"}{" "}
                          </td>
                        )}
                        <td
                          className="ordedetail__shdetails_tableitem"
                          data-label={t("orderDetails.productNotes")}
                          data-card="wide"
                          // style={{ maxWidth: "150px" }}
                        >
                          {item?.note ?? "-"}
                        </td>
                        {selectedStatus == "5" && (
                          <>
                            <td
                              className="ordedetail__shdetails_tableitem"
                              data-label={t("orderDetails.fulfilled")}
                            >
                              <div
                                style={
                                  type === "print"
                                    ? {
                                        color:
                                          item?.is_saleable != 1
                                            ? "red"
                                            : "green",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "4px",
                                      }
                                    : {
                                        color:
                                          item?.is_saleable != 1
                                            ? "red"
                                            : "green",
                                        display: "flex",
                                      }
                                }
                              >
                                {item?.is_saleable == 1 ? (
                                  <>
                                    <TiTick size={15} /> {t("common:actions.yes")}
                                  </>
                                ) : (
                                  <>
                                    <TiTimes size={15} /> {t("common:actions.no")}
                                  </>
                                )}
                              </div>
                            </td>
                            <td
                              className="ordedetail__shdetails_tableitem"
                              data-label={t("orderDetails.fulfilledQty")}
                              style={{
                                color: item?.is_saleable != 1 ? "red" : "",
                              }}
                            >
                              {item?.saleable_item_quantity ?? "-"}
                            </td>
                            <td
                              className="ordedetail__shdetails_tableitem"
                              data-label={t("orderDetails.fulfilmentNotes")}
                              data-card="wide"
                              style={{
                                color:
                                  item?.fulfillment_note &&
                                  item?.is_saleable != 1
                                    ? "red"
                                    : "",
                              }}
                            >
                              {/* The note typed while fulfilling; the
                                  shipper's own is under Product Notes. */}
                              {item?.fulfillment_note ?? "-"}
                            </td>
                          </>
                        )}
                        {item?.products?.product_pallets?.length > 0 ? (
                          <td
                            className="ordedetail__shdetails_tableitem"
                            data-label={t("orderDetails.locationHistory")}
                            data-card="wide"
                            style={{ maxWidth: "235px" }}
                          >
                            <table>
                              <thead className="ssummary_innertable_head">
                                <th
                                  style={{
                                    borderRight: "0.5px solid grey",
                                    width: "50px",
                                    height: "20px",
                                  }}
                                  className="min-w-[50px]"
                                >
                                  {t("orderDetails.unit")}
                                </th>
                                <th
                                  style={{
                                    borderRight: "0.5px solid grey",
                                    width: "80px",
                                    height: "20px",
                                  }}
                                  className="min-w-[80px] "
                                >
                                  {t("orderDetails.lotBatch")}
                                </th>
                                <th
                                  style={{
                                    borderRight: "0.5px solid grey",
                                    width: "50px",
                                    height: "20px",
                                  }}
                                  className="min-w-[50px] "
                                >
                                  {t("orderDetails.spot")}
                                </th>
                                <th
                                  style={{ width: "50px", height: "20px" }}
                                  className="min-w-[50px] "
                                >
                                  {t("orderDetails.qty")}
                                </th>
                              </thead>
                              <tbody>
                                {item?.products?.product_pallets?.map(
                                  (pallet, index) => {
                                    return (
                                      <>{getFulfilledQty(pallet, index)}</>
                                    );
                                  },
                                )}
                              </tbody>
                            </table>
                          </td>
                        ) : (
                          <td className="ordedetail__shdetails_tableitem"></td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="invmodal__shdetails_cntright">
              {/* <div className="add__dimension_button">
                <div className="add__dimension_buttonicon">
                  <AddIcon />{" "}
                </div>
                <div className="add__dimension_buttontext">
                  Billed Dimension, Weight and Volume
                </div>
              </div> */}
            </div>
          </div>
        ) : (
          <div className="shipment_order_not_available">
            <p>{t("orderDetails.productsNotAvailable")} </p>
          </div>
        )}
        <div className="invmodal__shipment_summaryhding package_detail_heading">
          {t("orderDetails.shipmentPackagesDetails")}
        </div>
        {data?.shipment ? (
          <>
            <div className="invmodal__shdetails_content shipment__summary_package_details">
              <div className="invmodal__shdetails_cntleft">
                <div className="orderdetails__cnleft_heading">{t("orderDetails.declared")}</div>
                <table className="invmshdetails_cnleft_table">
                  <thead>
                    <th className="ordedetail__shdetails_tablehd">#</th>
                    <th className="ordedetail__shdetails_tablehd">
                      {t("orderDetails.description")}
                    </th>
                    <th className="ordedetail__shdetails_tablehd parsel_id_heading">
                      {type == "show" ? (
                        <div className="invmodal__shdetails_tablehdinner ">
                          {t("orderDetails.parcelTrackingId")}{" "}
                          {data?.shipment?.parcel_id && copied !== "pid" ? (
                            <Tooltip title={t("orderDetails.copyAllParcelIds")}>
                              <span
                                className="invmodal__shdetails_modaltxtrtcopy"
                                onClick={handleCopyParcelId}
                              >
                                <MdOutlineContentCopy
                                  size={16}
                                  style={{ marginLeft: "10px" }}
                                />
                              </span>
                            </Tooltip>
                          ) : (
                            ""
                          )}
                          {data?.shipment?.parcel_id && copied === "pid" ? (
                            <span className="invmodal__shdetails_modaltxtrtcopy">
                              <FcCheckmark
                                size={16}
                                style={{ marginLeft: "10px" }}
                              />
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        t("orderDetails.parcelId")
                      )}
                    </th>
                    <th className="ordedetail__shdetails_tablehd">
                      {t("orderDetails.parcelStatus")}
                    </th>
                    {/* <th className="ordedetail__shdetails_tablehd">
                      {type == "show" ? (
                        <div className="invmodal__shdetails_tablehdinner ">
                          Carrier Tracking
                          {data?.shipment?.c_p_shipment_details?.length &&
                          copied !== "sid" ? (
                            <Tooltip title="Copy All Tracking IDs">
                              <span
                                className="invmodal__shdetails_modaltxtrtcopy"
                                onClick={handleCopy}
                              >
                                <MdOutlineContentCopy
                                  size={16}
                                  style={{ marginLeft: "10px" }}
                                />
                              </span>
                            </Tooltip>
                          ) : (
                            ""
                          )}
                          {data?.shipment?.c_p_shipment_details?.length &&
                          copied === "sid" ? (
                            <span className="invmodal__shdetails_modaltxtrtcopy">
                              <FcCheckmark
                                size={16}
                                style={{ marginLeft: "10px" }}
                              />
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        "Carrier Tracking"
                      )}
                    </th> */}
                    <th
                      className="ordedetail__shdetails_tablehd"
                      // style={{
                      //   borderTop: "2px solid var(--color-brand)",
                      // }}
                    >
                      {t("orderDetails.dimLxwxh")}
                    </th>
                    <th
                      className="ordedetail__shdetails_tablehd"
                      // style={{
                      //   borderTop: "2px solid var(--color-brand)",
                      // }}
                    >
                      {t("orderDetails.weight")}
                    </th>
                    <th
                      className="ordedetail__shdetails_tablehd"
                      // style={{
                      //   borderTop: "2px solid var(--color-brand)",
                      // }}
                    >
                      {t("orderDetails.volume")}
                    </th>
                  </thead>

                  <tbody>
                    {data?.shipment?.shipment_details?.map((item, index) => {
                      return (
                        <tr key={index}>
                          {" "}
                          <td
                            className="ordedetail__shdetails_tableitem"
                            data-label={t("orderDetails.parcel")}
                            data-card="index"
                          >
                            {index + 1}
                          </td>
                          <td
                            className="ordedetail__shdetails_tableitem"
                            data-label={t("orderDetails.description")}
                            data-card="wide"
                          >
                            {item.description ?? "-"}
                          </td>
                          <td
                            className="ordedetail__shdetails_tableitem"
                            data-label={t("orderDetails.parcelTrackingId")}
                          >
                            <HyperLink code={item?.parcel_id} />
                          </td>
                          <td
                            className="ordedetail__shdetails_tableitem"
                            data-label={t("orderDetails.parcelStatus")}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <StatusIcons
                                status={item?.tracking_status ?? "N/A"}
                                showTitle={type !== "print"}
                                isPrint={type === "print"}
                                noDot={type === "print"}
                                noBg
                              />
                              {item?.parcel_id &&
                                item?.tracking_status &&
                                type === "show" && (
                                  <Tooltip title={t("orderDetails.clickToViewHistory")}>
                                    <div>
                                      <MdOutlineHistory
                                        size={15}
                                        className="parcel__history_icone"
                                        onClick={() =>
                                          setDetailHistoryModal(item?.id)
                                        }
                                      />
                                    </div>
                                  </Tooltip>
                                )}
                            </div>
                          </td>
                          <td
                            className="ordedetail__shdetails_tableitem"
                            data-label={t("orderDetails.dimLxwxh")}
                          >
                            {item.length ?? "0"} x{item.width ?? "0"} x
                            {item.height ?? "0"} (
                            {data?.shipment?.unit === "Imperial" ? t("units.in") : t("units.cm")})
                          </td>
                          <td
                            className="ordedetail__shdetails_tableitem"
                            data-label={t("orderDetails.weight")}
                          >
                            {item.weight ?? "0"} (
                            {data?.shipment?.unit === "Imperial" ? t("units.lb") : t("units.kg")})
                            {/* {item.weight && "Lbs"} */}
                          </td>
                          <td
                            className="ordedetail__shdetails_tableitem"
                            data-label={t("orderDetails.volume")}
                          >
                            {item.volume ?? "0"} {/* {item.volume && "Cbf"} */}(
                            {data?.shipment?.unit === "Imperial"
                              ? t("units.cbm")
                              : t("units.cbf")}
                            )
                          </td>
                        </tr>
                      );
                    })}

                    <tr className="invmshdetails_cnleft_footer">
                      <td></td>
                      <td
                        className="ordedetail__shdetails_tableitem invmshdetails_cnleft_fitemttl"
                        data-card="title"
                      >
                        {t("orderDetails.total")}
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td
                        className="ordedetail__shdetails_tableitem"
                        data-label={t("orderDetails.weight")}
                      >
                        {data?.shipment?.total_weight ?? "0"} (
                        {data?.shipment?.unit === "Imperial" ? t("units.lb") : t("units.kg")})
                      </td>
                      <td
                        className="ordedetail__shdetails_tableitem"
                        data-label={t("orderDetails.volume")}
                      >
                        {" "}
                        {data?.shipment?.volume ?? "0"} (
                        {data?.shipment?.unit === "Imperial" ? t("units.cbm") : t("units.cbf")})
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="invmodal__shdetails_cntright"></div>
            </div>
          </>
        ) : (
          <div className="shipment_order_not_available">
            <p>{t("orderDetails.shipmentNotAvailable")} </p>
          </div>
        )}
      </div>
    </>
  );
}
